<style>
.img-fluid{
cursor: pointer;
}

.centered-link{
  display: flex;
  flex-direction: column;
  line-height: 1.2;
  font-size: 0.9em;
  text-align: center;
}

.slick-slider[data-v-3d1a4f76] {
width: 60%;

}

.col-lg-7 {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.slick-slide img[data-v-e4caeaf8] {
    display: block;
}
.data-v-e4caeaf8{
  width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.slick-arrow {
  font-size: 24px;
  color: #333;
  z-index: 10;
  border: none;
  background: transparent;
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.slick-arrow:hover {
color: #045C68;

}

.slick-prev {
  font-size: 3em;
  left: -30px;
}

.slick-next {

  font-size: 3em;
  right: -30px;
}
</style>

<template>
  <div id="lactationedn-view">
    <head>
      <meta name="description" content="ResMed Masks">
    </head>
    <section class="bg-light ftco-section">
      <div class="container" style="min-width: 90vw;">
        <h1 class="display-4 text-center  my-4">RESMED CPAP MASKS<br>
        <Span style="font-size: 0.3em;">(prescription required)</Span>
        </h1>
        <div class="row  my-5">
          <div class="col-md-12 col-lg-7">
            <VueSlickCarousel 
            ref="mainSlider"
            :arrows="true" 
            :fade="true" 
            :as-nav-for="$refs.thumbnailSlider"
            >
        <div v-for="image in images" :key="image.id">
          <img :src="image.src" :alt="image.alt" class="img-fluid" />
        </div>
        <template v-slot:prevArrow>
        <button class="slick-arrow slick-prev">
          <i class="fas fa-chevron-left"></i>
        </button>
      </template>
      <template v-slot:nextArrow>
        <button class="slick-arrow slick-next">
          <i class="fas fa-chevron-right"></i>
        </button>
      </template>
      </VueSlickCarousel>
      <VueSlickCarousel
        :slides-to-show="5"
        :focus-on-select="true"
        :as-nav-for="$refs.mainSlider"
        class="mt-2"
      >
        <div v-for="image in images" :key="image.id">
          <img :src="image.thumbnail" :alt="image.alt" class="img-fluid" />
        </div>
      </VueSlickCarousel>
          </div>
          <div class="col-md-12 col-lg-5">
            <h3 class="mt-5 mb-2 text-light1">ResMed AirFit F20 Full Face Mask For Her</h3>
            <div class="row mb-4">
              <div class="col">
                <span class="text3">Description</span>
              </div>
            </div>

            <p>
              The ResMed AirFit F20 Full Face CPAP Mask cushion conforms gently to your profile,
               maintaining a secure seal to allow for freedom of movement so you don’t feel tethered to your CPAP machine. 
               A flexible frame with no forehead support gives you a wide open field of vision as you settle into your BiPAP or CPAP therapy. The silicone InfinitySeal Cushion provides flexible, adaptive support for a secure mask fit, even as you move through multiple sleeping positions.
            </p>
            <div class="row mb-4">
              <div class="col">
              </div>
            </div>
            
              <div id="action-buttons" class="d-flex justify-content-between">
    <router-link to="/cpapform" class="btn btn-light mt-3" style="white-space: normal; font-size: 13px !important;" tag="button">
      Purchase with insurance
    </router-link>
  </div>

          </div>
        </div>
        <div class="row my-5">
  <div class="col-md-6">
    <h3 class="mt-5 mb-2 text-light1">Features</h3>
    <ul>
      <li>
        InfinitySeal silicone cushion is flexible enough to maintain a secure seal without over-tightening — no matter what your therapy pressure is
      </li>
      <li>
        Quick-Release Elbow allows you to easily disconnect from CPAP hose if you need to get up in the middle of the night


      </li>
      <li>
        QuietAir diffuser vent minimizes noise by evenly dispersing air out of the mask


      </li>
      <li>
        Flexible mask frame design fits nearly all patients


      </li>
      <li>
        Magnetic clips enable you to easily attach and detach the plush headgear from the mask. Please note that headgear does not automatically come with the order. If you'd like your purchase to include headgear, please select your headgear option.


      </li>
    </ul>
  </div>
  <div class="col-md-6">
    <h3 class="mt-5 mb-2 text-light1"></h3>
    <ul>
     

    </ul>
  </div>
</div>

      </div>

      
    </section>
  </div>


  
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import '@fortawesome/fontawesome-free/css/all.css'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

export default {
  components: {
    VueSlickCarousel,
  },
  data() {
  return {
    images: [
      { id: 1, src: require('@/assets/site/CPAP/AirFitF20FullFaceMaskForHer/1.webp'), thumbnail: require('@/assets/site/CPAP/AirFitF20FullFaceMaskForHer/1.webp'), alt: 'Image 1' },
      { id: 2, src: require('@/assets/site/CPAP/AirFitF20FullFaceMaskForHer/2.webp'), thumbnail: require('@/assets/site/CPAP/AirFitF20FullFaceMaskForHer/2.webp'), alt: 'Image 2' },
    ],
  }
},
mounted() {
  this.$nextTick(() => {
    const arrows = this.$el.querySelectorAll('.slick-arrow');
    arrows.forEach(arrow => {
      arrow.addEventListener('click', () => {
        arrow.blur();
      });
    });
  });
}

}
</script>
